import Vue from "vue";
import moment from "moment-timezone";

Vue.filter('dateFormat', function (value, format = 'YYYY-MM-DD') {
    if (!value) return '';
    return moment(value).format(format);
});

Vue.filter('dateFormatUTC', function (value, format = 'YYYY-MM-DD') {
    if (!value) return '';
    return moment(value).utc().format(format);
});

Vue.filter('dateTimeFormat', function (value, format = 'YYYY-MM-DD hh:mm:ss a') {
    if (!value) return '';
    return moment(value).format(format);
});

Vue.filter('dateTime24Format', function (value, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!value) return '';
    return moment(value).format(format);
});

Vue.filter('dateTime24HoursFormat', function (value, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!value) return '';
    return moment(value).format(format);
});

Vue.filter('timeFormat', function (value, format = 'hh:mm:ss') {
    if (!value) return '';
    return moment(value).format(format);
});

Vue.filter('dateTime24HoursUTCFormat', function (value, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!value) return '';
    return moment(value).utc().format(format);
});

Vue.filter('playerPosition', function (value, player) {
    const playerC = value.playerCollection.find(p => p.id === player.id);
    return  playerC ? playerC.finalClassificationPlace : '';
});


Vue.filter('gamePrize', function (value, player) {
    const playerC = value.playerCollection.find(p => p.id === player.id);
    return  playerC ? playerC.award : '0,00';
});

Vue.filter('sexDict', function (value) {
    switch (value) {
        case 1 || '1': {
            return 'sex.male';
        }
        case 2 || '2': {
            return 'sex.female'
        }
    }
});

Vue.filter('numberFormat', function (value, roundTo = 2) {
    if (value || value === 0) {
        return getRoundedValue(value, roundTo);
    }
});


Vue.filter('shortId', function (value) {
    return value.split('-')[0]
});

function getRoundedValue(value, roundTo) {

    // Replace the comma with dot to make string which will be parsed to number.
    value = value.toString().replace(/,/g, '.');

    // TODO: I don't know what exactly here be, but it seems to be two types of spaces. Ensure to replace all of them.
    value = value.replace(/ /g, '');
    // eslint-disable-next-line no-irregular-whitespace
    value = value.replace(/ /g, '');
    // Parse string to number.
    value = Number(value);

    // If the value is not a number, replace it to 0.
    if (!value) {
        value = 0;
    }

    // Get where is a dot.
    const dotIndex = value.toString().indexOf('.');

    // If the dot doesn't exist it means that number is rounded eg 3, 11, 923.
    if (dotIndex === -1 || roundTo === 0) {
        // So, round the number to 2 decimals eg 3.00, 11.00, 923.000
        value = value.toFixed(roundTo);
    } else {
        // If the dot exists, it means the number may be like 3.02323, 11.2
        // So, round its to the 'this.roundTo' value.
        // Eg 3.02, 11.20. (for this.roundTo = 2)
        value = value.toString().substring(0, dotIndex + roundTo + 1);

        // Get how many decimals number the value has.
        // Eg 12.1 => 3, 12.233 = 3
        const decimalsLength = value.split('.')[1].length;

        // If the number is smaller than the roundTo value, it means that the value has to be filled by zeros.
        // Eg.
        // value = 12.3;
        // this.roundTo = 3;
        // this.decimalsLength = 1;
        // So, the value should has 3 digits after comma, currently has only 1.
        // In this case, convert 12.3 to 12.300.
        if (decimalsLength < roundTo) {

            const fillAmount = roundTo - decimalsLength;

            value += '0'.repeat(fillAmount);
        }
    }

    // At the end, convert the dot to the comma.
    // Eg. 12.26 => 12,26
    value = value.replace(/\./g, ',');

    // And format the value to get spaces between thousands.
    let splitted = value.split('.');
    splitted[0] = splitted[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    value = splitted.join('.');

    return value;
}

export function formatStringToFloat(value) {
    value = value.toString().replace(/,/g, '.');
    value = value.replace(/ /g, '');
    value = Number(value);

    return value;
}
